import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { LeaderCriteriaRuleResponse } from "~pages/LeaderCriteria/types/leaderCriteriaRule.ts";
import type { UpdateLeaderCriteriaRuleModel } from "~pages/LeaderCriteria/types/leaderCriteriaRuleModel.ts";

export const useUpdateLeaderCriteriaRule = () => {
  const { sport, organizationId, leaderCriteriaId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  return useMutation<LeaderCriteriaRuleResponse, Error, UpdateLeaderCriteriaRuleModel>({
    mutationFn: async ({ qualifierId, ...body }) =>
      await request<LeaderCriteriaRuleResponse>(
        `${sport}/o/${organizationId}/statistics/leaders/criteria/${leaderCriteriaId}/qualifiers/${qualifierId}`,
        {
          method: "PUT",
          body,
        },
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["leaderCriteriaRules", sport, organizationId, leaderCriteriaId] });
    },
  });
};
